import * as React from "react";
import { useDropzone } from "react-dropzone";
import i18n from "i18n";
import { Typography } from "@material-ui/core";
import cone from "common/assets/images/cone.png";

const stylesTable = {
  display: "grid",
  height: "calc(100vh - 105px)",
  width: "100%",
  alignItems: "center",
};

const stageTitle = {
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: 700,
  color: "rgba(255,255,255,0.87)",
};

const stageSubtitle = {
  fontFamily: "Roboto",
  fontSize: "11px",
  fontWeight: 300,
  color: "rgba(255,255,255,0.67)",
};

const Dropzone = ({ onDrop, accept }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
  });

  return (
    <div {...getRootProps()}>
      <input className="dropzone-input" {...getInputProps()} />
      <div id="dropzone-text" style={stylesTable}>
        <div id="dropzone-align">
          <img src={cone} />
          {isDragActive ? (
            <Typography style={stageSubtitle} component="span">
              {i18n.library.empty.subtitle2}
            </Typography>
          ) : (
            <div>
              <Typography style={stageTitle} component="span">
                {i18n.library.empty.title}
              </Typography>
              <Typography style={stageSubtitle} component="span">
                {i18n.library.empty.subtitle1}
              </Typography>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dropzone;



// WEBPACK FOOTER //
// ./src/modules/library/components/layouts/Dropzone.tsx